<template>
  <div class="countDown" @click="click">
    <span class="text-regular alinhamento" v-html="countDown(row)"></span>
  </div>
</template>
<script>
import moment from 'moment'

export default {
  props: ['column', 'row'],
  methods: {
    countDown (val) {
      const hoje = moment()
      const data = moment(val.dataHora)
      if (hoje.isBefore(val.dataHora) && !val.status.encerrado) {
        const diferenca = data.diff(hoje, 'days')

        if (diferenca === 0) {
          const hours = data.diff(hoje, 'hours')
          if (hours <= 0) {
            const minutes = data.diff(hoje, 'minutes')
            if (minutes >= 1) {
              return `Faltam <strong"> ${minutes} </strong> minutos`
            }
            return ''
          }
          return `Faltam <strong> ${hours} </strong> horas`
        }
        if (diferenca < 0) {
          return ''
        }
        return `Faltam <strong> ${diferenca} </strong> dias`
      } else {
        return `<p style="color: ${val.status.cor}"> ${val.status.descricao} </p>`
      }
    },
    click () {
      if (this.column && this.column.click) {
        this.column.click(this.row)
      }
      this.$emit('click', this.row)
    }
  }
}
</script>
<style lang="less" scoped>
.countDown {
  display: flex;
  justify-content: space-between;
  align-items: center;

  i {
    color: #09B531;
    font-size: 20px;
  }
}
</style>
